import script from "./VitaShiftMenuDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaShiftMenuDialog.vue?vue&type=script&lang=ts&setup=true"

import "./VitaShiftMenuDialog.vue?vue&type=style&index=0&id=b59338ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b59338ca"]])

export default __exports__